(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-guide-content"] && !Shopify.designMode) return;
  try {
    (function () {
    var dialogCount = 0;
    function format(n) { return (Math.round(n * 100) / 100).toString(); }

    function setupIllustration(root, mount, img) {
      var dialog = root.querySelector('[data-size-guide-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') {
        mount.appendChild(img);
        return;
      }
      var opener = document.createElement('button');
      opener.type = 'button';
      opener.className = 'size-guide__zoom-trigger';
      opener.setAttribute('aria-label', root.dataset.enlargeLabel);
      opener.setAttribute('aria-haspopup', 'dialog');
      opener.setAttribute('aria-expanded', 'false');
      dialog.id = 'SizeGuideZoom-' + (++dialogCount);
      opener.setAttribute('aria-controls', dialog.id);
      opener.appendChild(img);
      var hint = document.createElement('span');
      hint.className = 'size-guide__zoom-hint';
      hint.textContent = root.dataset.enlargeLabel;
      opener.appendChild(hint);
      mount.appendChild(opener);

      // Move the dialog outside the animated accordion; leave the original
      // high-resolution source URL intact for both inline and enlarged views.
      document.body.appendChild(dialog);
      var stage = dialog.querySelector('[data-size-guide-stage]');
      var canvas = dialog.querySelector('[data-size-guide-canvas]');
      var toggle = dialog.querySelector('[data-size-guide-zoom-toggle]');
      var close = dialog.querySelector('[data-size-guide-close]');
      var enlarged = img.cloneNode(true);
      enlarged.removeAttribute('id');
      enlarged.removeAttribute('width');
      enlarged.removeAttribute('height');
      enlarged.loading = 'eager';
      canvas.appendChild(enlarged);
      var previousOverflow;
      var zoomed = false;

      function setZoom(value) {
        zoomed = value;
        var width = Math.min(enlarged.naturalWidth || 1600, Math.max(720, stage.clientWidth * 2));
        dialog.style.setProperty('--sg-zoom-width', width + 'px');
        dialog.classList.toggle('is-zoomed', value);
        toggle.textContent = value ? root.dataset.fitLabel : root.dataset.zoomInLabel;
        toggle.setAttribute('aria-pressed', value ? 'true' : 'false');
        requestAnimationFrame(function () {
          stage.scrollLeft = value ? Math.max(0, (stage.scrollWidth - stage.clientWidth) / 2) : 0;
          stage.scrollTop = value ? Math.max(0, (stage.scrollHeight - stage.clientHeight) / 2) : 0;
        });
      }

      opener.addEventListener('click', function () {
        if (dialog.open) return;
        previousOverflow = document.body.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        opener.setAttribute('aria-expanded', 'true');
        // On phones, open enlarged rather than showing another tiny thumbnail.
        setZoom(window.matchMedia('(max-width: 600px)').matches);
        close.focus();
      });
      toggle.addEventListener('click', function () { setZoom(!zoomed); });
      enlarged.addEventListener('click', function () { setZoom(!zoomed); });
      close.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;
        var rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', function () {
        document.body.style.overflow = previousOverflow;
        opener.setAttribute('aria-expanded', 'false');
        opener.focus({ preventScroll: true });
      });
      document.addEventListener('shopify:section:unload', function (event) {
        if (!event.target.contains(root)) return;
        if (dialog.open) dialog.close();
        dialog.remove();
      });
    }

    function buildGrid(src) {
      var rows = Array.prototype.map.call(src.querySelectorAll('tr'), function (tr) {
        return Array.prototype.map.call(tr.querySelectorAll('th,td'), function (c) {
          return c.textContent.trim();
        });
      }).filter(function (r) { return r.length; });
      if (!rows.length) return document.createElement('div');

      var header = rows[0];
      var bodyRows = rows.slice(1);
      var numCols = header.length - 1;

      var grid = document.createElement('div');
      grid.className = 'sg-grid';
      grid.style.setProperty('--cols', numCols);
      grid.setAttribute('role', 'table');

      var headEmpty = document.createElement('div');
      headEmpty.className = 'sg-cell sg-head sg-head--first';
      headEmpty.setAttribute('role', 'columnheader');
      grid.appendChild(headEmpty);

      for (var i = 1; i < header.length; i++) {
        var headCell = document.createElement('div');
        headCell.className = 'sg-cell sg-head';
        headCell.setAttribute('role', 'columnheader');
        headCell.textContent = header[i];
        grid.appendChild(headCell);
      }

      bodyRows.forEach(function (row) {
        var labelCell = document.createElement('div');
        labelCell.className = 'sg-cell sg-label';
        labelCell.setAttribute('role', 'rowheader');
        labelCell.textContent = row[0];
        grid.appendChild(labelCell);

        for (var j = 1; j < row.length; j++) {
          var valCell = document.createElement('div');
          valCell.className = 'sg-cell sg-value';
          valCell.setAttribute('role', 'cell');
          var num = parseFloat((row[j] || '').replace(',', '.'));
          if (!isNaN(num)) {
            valCell.dataset.cm = num;
            valCell.textContent = format(num);
          } else {
            valCell.textContent = row[j];
          }
          grid.appendChild(valCell);
        }
      });

      return grid;
    }

    function setupOne(root) {
      if (root.dataset.sgReady) return;
      root.dataset.sgReady = '1';

      var source = root.querySelector('[data-size-guide-source]');
      var illustrationMount = root.querySelector('[data-size-guide-illustration]');
      var tableMount = root.querySelector('[data-size-guide-table]');
      var notesMount = root.querySelector('[data-size-guide-notes]');
      var buttons = root.querySelectorAll('.size-guide__unit');
      if (!source) return;

      var img = source.querySelector('img');
      if (img) setupIllustration(root, illustrationMount, img);
      else root.querySelector('[data-size-guide-dialog]').remove();

      var sourceTable = source.querySelector('table');
      if (sourceTable) tableMount.appendChild(buildGrid(sourceTable));

      var tmp = source.cloneNode(true);
      var t = tmp.querySelector('table'); if (t) t.remove();
      tmp.querySelectorAll('img').forEach(function (i) { i.remove(); });
      tmp.querySelectorAll('p, div').forEach(function (el) {
        if (!el.textContent.trim() && !el.querySelector('img')) el.remove();
      });
      if (tmp.innerHTML.trim()) notesMount.innerHTML = tmp.innerHTML;

      var cells = tableMount.querySelectorAll('[data-cm]');

      function setUnit(unit) {
        buttons.forEach(function (b) {
          var active = b.dataset.unit === unit;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        cells.forEach(function (cell) {
          var cm = parseFloat(cell.dataset.cm);
          if (isNaN(cm)) return;
          cell.textContent = unit === 'in' ? (cm / 2.54).toFixed(1) : format(cm);
        });
      }

      buttons.forEach(function (b) {
        b.addEventListener('click', function () { setUnit(b.dataset.unit); });
      });

      setUnit('cm');
    }

    function init() {
      document.querySelectorAll('[data-size-guide]').forEach(setupOne);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
